import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FetchDataService {
  private mainURL = '../../../assets/' + environment.projectName + '/content/';
  private dashboardURL = '../../../assets/';
  private cofigURL = '../../../config/config.json';
  private styleUrl = '../../../assets/' + environment.projectName + '/style.json';

  constructor(private http: HttpClient) {}

  getJsonData(lang: string, pageName: string, fileName: string) {
    return this.http.get<any[]>(
      this.mainURL + lang + '/' + pageName + '/' + fileName + '.json'
    );
  }
  getJSONServicesByFileName(
    projectName: string,
    pageName: string,
    filename: string
  ): Observable<any[]> {
    const languages = ['en', 'ar', 'de'];
    const requests = languages.map((lang) =>
      this.http
        .get<any>(
          `${this.dashboardURL}${projectName}/content/${lang}/${pageName}/${filename}.json`
        )
        .pipe(
          catchError((error) => {
            console.error('Error fetching file:', error);
            return of(null);
          })
        )
    );
    return forkJoin(requests);
  }

  updateJsonData(
    projectName: string,
    pageName: string,
    filename: string,
    id: number,
    lang: string,
    data: any
  ): Observable<any> {
    const url = `http://localhost:5000/update/${projectName}/content/${lang}/${pageName}/${filename}.json`;
    const payload = {
      id: id,
      data: data,
    };
    return this.http.post(url, payload);
  }

  getConfigFile(): Observable<any> {
    return this.http.get<any[]>(this.cofigURL);
  }

  getJSONfooter(): Observable<any> {
    return this.http.get<any[]>(this.mainURL + '/common/footer.json');
  }
  getJSONheader(): Observable<any> {
    return this.http.get<any[]>(this.mainURL + '/common/header.json');
  }

  getSocialLinkes() {
    return this.http.get<any[]>(this.mainURL + '/common/socialMediaLinks.json');
  }

  loadStyles(): Observable<any> {
    return this.http.get<any>(this.styleUrl);
  }
}
